import WsProvider from './provider/WSProvider'


var base64 = require('base64_js');
var serviceName = "firma";
var firmaService = {

    firmaTanimlama(firmaKodu, firmaAdi, siteAdi, vergiDairesi, vergiNo, slogan, siteAdresi, siteAdresi2,renk,eposta, eposta2, telefon, sabitTelefon, dahili, fax, adres, koordinat, map, sosyalMedya) {
        var userDataEstas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataEstas"))));
        var param = {
            data: {
                yonetimId: userDataEstas["yonetimId"],
                userToken: userDataEstas["token"],
                firmaKodu: firmaKodu,
                firmaAdi: firmaAdi,
                siteAdi: siteAdi,
                vergiDairesi: vergiDairesi,
                vergiNo: vergiNo,
                slogan: slogan,
                siteAdresi: siteAdresi,
                siteAdresi2: siteAdresi2,
                renk: renk,
                eposta: eposta,
                eposta2: eposta2,
                telefon: telefon,
                sabitTelefon: sabitTelefon,
                dahili: dahili,
                fax: fax,
                adres: adres,
                koordinat: koordinat,
                map: map,
                sosyalMedya: sosyalMedya,
                methodName: "tanimlama"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },
    firmaDetay() {
        var userDataEstas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataEstas"))));
        var param = {
            data: {
                yonetimId: userDataEstas["yonetimId"],
                userToken: userDataEstas["token"],
                firmaKodu: userDataEstas["firmaKodu"],
                methodName: "firmaDetay"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },
    firmaGuncelle(updateList) {
        var userDataEstas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataEstas"))));
        var param = {
            data: {
                yonetimId: userDataEstas["yonetimId"],
                userToken: userDataEstas["token"],
                firmaKodu: userDataEstas["firmaKodu"],
                updateList: updateList,
                methodName: "firmaGuncelleme"
            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },

};
export default firmaService